import React from 'react'
import { Row, Col } from 'react-bootstrap'
import axios from 'axios';
import './style.scss'

import NPTreeMenu from '../NPTreeMenu'
import NewsPresentation from './NewsPresentation'
import LoadingSpinner from '../LoadingSpinner';
import constants from '../util/constants';
import NPPanel from '../NPPanel';
import FacebookProvider, { Page} from 'react-facebook'

const { API_BASE_URL } = constants;

class News extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            entry: {},
            entryLoading: false,
            treeLoading: true,
            header: this.props.apiToken ? {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            } : {},
            treeData: [],
            currentNewsId: props.match?.params?.id || null // Get ID from url. Needs props passed om <Route>
        }

        this.dataCallback = this.dataCallback.bind(this)
        this.toggleEntryLoading = this.toggleEntryLoading.bind(this);
    }

    async componentDidMount() {
        const { currentNewsId, header } = this.state
        this.setState({ treeLoading: true });

        if (currentNewsId) {
            this.setState({ entryLoading: true })
            axios.get(API_BASE_URL + `News/GetSingleNews?id=${currentNewsId}`, { headers: header })
                .then(result => {
                    this.setState({ entry: result.data, entryLoading: false });
                })
                .catch(error => {
                    console.log(error)
                    this.setState({ entry: null, entryLoading: false });
                });
        }

        axios.get(API_BASE_URL + 'News/GetAllNews', { headers: header })
            .then(result => {
                if (result && result.data) {
                    result.data.forEach((e) => {
                        if (e.nodes)
                            e.nodes.forEach((n) => {
                                n.url = (API_BASE_URL + 'News/GetSingleNews?id=' + n.url)
                            });
                        e.url = null;
                    });
                }
                this.setState({ treeLoading: false, successMessage: 'Success', errorMessage: null, treeData: result.data })
            })
            .catch(error => {
                this.setState({ treeLoading: false, errorMessage: 'Problem loading news', successMessage: null })
            });
    }

    dataCallback(data) {
        this.setState({
            entry: data.data,
            entryLoading: false
        });
    }

    toggleEntryLoading(currentState) {
        this.setState({
            entryLoading: currentState
        });
    }

    render() {
        const { entry, entryLoading, treeLoading, treeData, header } = this.state
        const { dataCallback, toggleEntryLoading } = this

        return (
            <NPPanel>
                <Row className="d-flex">
                    <Col md={4} lg={3} className="news--treeMenu">
                        {
                            treeLoading
                                ? <LoadingSpinner isLoading={true} />
                                : <NPTreeMenu data={treeData} level0DefaultOpen={true} dataCallback={dataCallback} header={header} toggleContentLoading={toggleEntryLoading} />
                        }
                    </Col>
                    <Col md={4} lg={4}>
                        {
                            entryLoading
                                ? <LoadingSpinner isLoading={true} />
                                : <NewsPresentation entry={entry} header={header} />
                        }
                    </Col>
                    <Col md={4} lg={5}>
                        <div className='facebook-container'>
                            <FacebookProvider appId="1750212728346928">
                                <Page href="https://www.facebook.com/Nordic-Paper-1518197315083296/" lazy width={550} height={620}/>
                            </FacebookProvider>
                        </div>
                    </Col>
                </Row>
            </NPPanel>

        );
    }
}

export default News;